module.exports = __webpack_public_path__ + "static/img/1807-54_1.45f42c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1807-54_1.jpg
// module id = vtEn
// module chunks = 1